module.exports = __webpack_public_path__ + "img/icon_checkbox_unchecked.54b71d23.svg";